import StatisticsCtrl from "./controllers/statistics";
import StatisticExportCtrl from "./controllers/export";
import AbTestStatisticsCtrl from "./controllers/ab-test";
import Statistics from './statistics.repository';
import ChartData from './services/chartData';
import Google from './services/google';
import subscriberList from "./directives/subscriber-list";
import linkList from "./directives/link-list";
import chart from './directives/charts';
import subscriberBlockStatistics from "./directives/subscriber-block-statistics";
import abTestCampaigns from "./directives/ab-test-campaigns";
import routing from './statistics.routes';
import uirouter from 'angular-ui-router';

export default angular.module('app.statistics', [uirouter])
    .config(routing)
    .controller('StatisticsCtrl', StatisticsCtrl)
    .controller('StatisticExportCtrl', StatisticExportCtrl)
    .controller('AbTestStatisticsCtrl', AbTestStatisticsCtrl)
    .directive('chart', () => new chart)
    .directive('subscriberList', () => new subscriberList)
    .directive('linkList', () => new linkList)
    .directive('subscriberBlockStatistics', () => new subscriberBlockStatistics)
    .directive('abTestCampaigns', () => new abTestCampaigns)
    .service('Statistics', Statistics)
    .service('ChartData', ChartData)
    .service('Google', Google)
    .name;